import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { useFetcher } from '../api/fetcher';
import { GetAresDataDocument, GetAresDataQuery, GetAresDataQueryVariables } from '../api/gql';

/**
 * Custom fetch hook for making the query be called only once with variables provided at the time of action call.
 *
 * @param options
 */
const useGetAresDataQuery = <TData = GetAresDataQuery, TError = { message: string; code: number }>(
  options?: UseMutationOptions<GetAresDataQuery, TError, GetAresDataQueryVariables, TData>,
) =>
  useMutation<GetAresDataQuery, TError, GetAresDataQueryVariables, TData>({
    mutationKey: ['GetAresData'],
    mutationFn: useFetcher<GetAresDataQuery, GetAresDataQueryVariables>(GetAresDataDocument),
    ...options,
  });
useGetAresDataQuery.document = GetAresDataDocument;

type Props = {
  onSuccess?: (data: GetAresDataQuery) => void;
  onError?: (data: GetAresDataQuery) => void;
};

export const useAresSearch = (props?: Props) => {
  const { mutateAsync, isPending } = useGetAresDataQuery({
    onSuccess: props?.onSuccess,
    onError: props?.onSuccess,
  });

  return {
    search: mutateAsync,
    state: {
      isPending,
    },
  };
};
